<div class="container-fluid h-100">
  <h1 class="font-34 font-trueno-bold">Services disponibles</h1>
  <div class="d-flex flex-row gap-16 flew-wrap">
    <div class="w-25 p-3 br-24 border pointer d-flex align-items-end justify-content-center font-24 service-box fw-bold text-white position-relative bgcover"
         [routerLink]="[service.url]" *ngFor="let service of services" [ngClass]="[service.class]">
      <div class="position-absolute br-24" [style.background-image]="'url(\'/assets/img/showcase/Landing1/services/'+ service.class+ '-icon.svg\')'" *ngIf="service.icon"></div>
      <span>{{ service.name }}</span>
    </div>
  </div>
</div>
